import _get from "lodash/get";
import React, { useContext } from 'react';
import { rem } from 'polished';
import { ThemeContext } from 'styled-components';
import { animated, useTransition } from 'react-spring';
import { GaIcon } from '@luigiclaudio/ga-baseline-ui/icon';
import { baseTheme } from '@luigiclaudio/ga-baseline-ui/base-theme';
import Container from './Container';
import FeedbackLabel from './FeedbackLabel';
import FeedbackIcon from './FeedbackIcon';
import alertTheme from '../../styles/alertTheme';
import alertPropTypes from '../../prop-types/alertPropTypes';

var AlertFeedback = function AlertFeedback(_ref) {
  var alertType = _ref.alertType,
      alertMessage = _ref.alertMessage,
      inProp = _ref.inProp,
      isFullScreen = _ref.isFullScreen;
  var theme = useContext(ThemeContext);

  var iconColor = _get(theme, "base.colors." + alertType, baseTheme.base.colors[alertType]);

  var icon = _get(theme, "base.icons." + alertType, baseTheme.base.icons[alertType]);

  var iconSize = _get(theme, 'alert.alertFeedback.icon.size', alertTheme.alert.alertFeedback.icon.size);

  var transition = useTransition(inProp, null, {
    from: {
      opacityContainer: 0,
      opacityLabel: 0,
      yIcon: -50
    },
    enter: {
      opacityContainer: 1,
      opacityLabel: 1,
      yIcon: 0
    },
    leave: {
      opacityContainer: 0,
      opacityLabel: 0,
      yIcon: -50
    }
  });
  var AnimatedContainer = animated(Container);
  var AnimatedIcon = animated(FeedbackIcon);
  var AnimatedLabel = animated(FeedbackLabel);
  return transition.map(function (_ref2) {
    var item = _ref2.item,
        key = _ref2.key,
        styles = _ref2.props;
    return item && /*#__PURE__*/React.createElement(AnimatedContainer, {
      key: key,
      style: {
        opacity: styles.opacityContainer
      },
      role: "alert",
      isFullScreen: isFullScreen
    }, /*#__PURE__*/React.createElement(AnimatedIcon, {
      style: {
        opacity: styles.opacityLabel,
        transform: styles.yIcon.interpolate(function (value) {
          return "translate3d(0, " + rem(value) + ", 0)";
        })
      }
    }, /*#__PURE__*/React.createElement(GaIcon, {
      icon: icon,
      size: iconSize,
      color: iconColor
    })), /*#__PURE__*/React.createElement(AnimatedLabel, {
      alertType: alertType,
      style: {
        opacity: styles.opacityLabel
      }
    }, alertMessage));
  });
};

AlertFeedback.defaultProps = {
  alertMessage: undefined,
  inProp: false,
  alertType: 'info',
  isFullScreen: false
};
export default AlertFeedback;